import { render } from "./InvitacionesPersonalizadasNew.vue?vue&type=template&id=6b1e3187&scoped=true"
import script from "./InvitacionesPersonalizadasNew.vue?vue&type=script&lang=js"
export * from "./InvitacionesPersonalizadasNew.vue?vue&type=script&lang=js"

import "./InvitacionesPersonalizadasNew.vue?vue&type=style&index=0&id=6b1e3187&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1e3187"]])

export default __exports__